import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import TicketDetailsView from './TicketDetailsView';
import { fetchTicketsPerBank } from '../../api/salesMonitoring';
import './TicketsPerBankView.css';

const TicketsPerBankView = ({ row, product, numero, date, rawDate, tirage, onBack }) => {
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    fetchTicketsPerBank({ tirage, date: rawDate, product, numbers: numero, bank: row.bank })
      .then((data) => { if (!cancelled) setTickets(data); })
      .catch(() => { if (!cancelled) setError('Impossible de charger les tickets — verifie que le serveur backend tourne.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [tirage, rawDate, product, numero, row.bank]);

  const totalPoints = tickets.reduce((s, r) => s + r.points, 0);
  const totalAmount = tickets.reduce((s, r) => s + r.amount, 0);

  if (selectedTicket !== null) {
    return (
      <TicketDetailsView
        ticket={selectedTicket}
        bankDesc={row.desc}
        date={date}
        onBack={() => setSelectedTicket(null)}
      />
    );
  }

  return (
    <Layout>
      <div className="tpb-wrapper">
        <div className="tpb-card">
          <div className="tpb-card-header">
            <span className="tpb-card-title">Tickets per Bank</span>
          </div>

          <div className="tpb-info">
            <div className="tpb-info-row">
              <span className="tpb-info-label">Bank</span>
              <span className="tpb-info-val">{row.desc}</span>
            </div>
            <div className="tpb-borlette-row">
              <span className="tpb-borlette-label">{product} :</span>
              <span className="tpb-borlette-val">{numero}</span>
            </div>
            <div className="tpb-info-row">
              <span className="tpb-date-box">Date</span>
              <span className="tpb-date-val">{date} :</span>
            </div>
          </div>

          <div className="tpb-table-bar"></div>

          {error && <p className="tpb-error">{error}</p>}
          {loading && <p className="tpb-loading">Chargement...</p>}

          {!loading && !error && (
            <table className="tpb-table">
              <thead>
                <tr>
                  <th>Sequence</th>
                  <th>Ticket</th>
                  <th>Point's Total</th>
                  <th>Amount</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {tickets.map((r, i) => (
                  <tr key={i} className={i % 2 === 0 ? 'tpb-row-even' : 'tpb-row-odd'}>
                    <td>{r.sequence}</td>
                    <td>
                      <span
                        className="tpb-ticket-box tpb-ticket-link"
                        onClick={() => setSelectedTicket(r.sequence)}
                      >{r.ticket}</span>
                    </td>
                    <td>{r.points.toFixed(2)}</td>
                    <td>{r.amount.toFixed(2)}</td>
                    <td>{r.time}</td>
                  </tr>
                ))}
                <tr className="tpb-total-row">
                  <td colSpan="2"><strong>Total:</strong></td>
                  <td><strong>{totalPoints.toFixed(2)}</strong></td>
                  <td><strong>{totalAmount.toFixed(2)}</strong></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        <div className="tpb-actions">
          <button className="tpb-back-btn" onClick={onBack}>↩</button>
          <button className="tpb-menu-btn">☰<br /><span>Menu</span></button>
        </div>
      </div>
    </Layout>
  );
};

export default TicketsPerBankView;
